// Thin wrapper around Umami's global. Safe no-op if blocked or not yet loaded.
export function track(name, data) {
  if (typeof window === 'undefined') return;
  try {
    const u = window.umami;
    if (u && typeof u.track === 'function') {
      data ? u.track(name, data) : u.track(name);
    }
  } catch {
    // swallow — analytics must never break the page
  }
}
